import React from 'react';
import { Helmet } from 'react-helmet';
import './Home.css';

const Home = () => {
  return (
    <>
    <Helmet>
      <title>About Us | GEMCO</title>
      <meta name="description" content="Looking for a reliable MEP contractor? Gemco brings 25+ years of experience and 105+ successful projects delivering trusted engineering solutions." />
      <meta name="keywords" content="MEP contractor, MEP services UAE, mechanical electrical plumbing, engineering contractor, construction MEP solutions, MEP installation, MEP maintenance, UAE construction company, reliable MEP contractor, building services engineering, HVAC installation, electrical works UAE, plumbing services UAE, commercial construction MEP, industrial MEP solutions" />
    </Helmet>
    <div className='wp_about_home'>
        <div className="container wp_about_text">
            <h1>About Gemco</h1>
            <p>Specialist MEP works. 25 years. 150+ projects. Built on reliability.</p>
        </div>
    </div>
    </>
  )
}

export default Home